import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'molla-premium-main-carousel',
  templateUrl: './premium-main-carousel.component.html',
  styleUrls: ['./premium-main-carousel.component.scss']
})
export class PremiumMainCarouselComponent implements OnInit {
  @Input() slides: Array<any> = [];
  @Input() type: string = 'Image';

  constructor() { }

  ngOnInit() { }
}
